module.exports = __webpack_public_path__ + "static/media/31.101.8ebb3cb5.webp";